import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { UserAuthorizationService } from '../services/user-authorization.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(protected authService: UserAuthorizationService) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = await this.authService.isLoggedIn();

        if (isLoggedIn) return true;

        // Save current path to redirect back after login
        const redirectUrl = state.url;
        this.authService.login(redirectUrl);

        return false;
    }

    async ensureUserIsLoggedIn(state: RouterStateSnapshot): Promise<boolean> {
        const user = await this.authService.getOrLoadUser();
        if (user) return true;

        this.authService.login();

        return false;
    }
}